import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Stack, styled, Typography, Button } from '@mui/material'
import type { FC } from 'react'

import { COLORS, ICONS, unit } from '@hcr/ui'

interface DestinationProps {
  description: string
  isActive: boolean
  onClick: () => void
  title: string
}

export const Destination: FC<DestinationProps> = ({ description, isActive, onClick, title }) => {
  return (
    <Container
      sx={{
        backgroundColor: isActive ? COLORS.hiekka[500] : COLORS.vaalea['60%'],
        color: isActive ? COLORS.white : COLORS.black,
        borderLeft: isActive ? `${unit(1)} solid ${COLORS.burgundi[500]}` : 'none',
      }}
      onClick={onClick}
    >
      <Stack direction='column' width={'100%'}>
        <Stack direction='row' alignItems='center' justifyContent='space-between'>
          <Typography component='h2' color={COLORS.burgundi[500]} variant='displayS'>
            {title}
          </Typography>
          <FontAwesomeIcon aria-hidden='true' fontSize={unit(5)} icon={ICONS.fasChevronRight} color={COLORS.black} />
        </Stack>
        <Typography color={COLORS.black} variant='bodyM'>
          {description}
        </Typography>
      </Stack>
    </Container>
  )
}

const Container = styled(Button)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${unit(4)};
  padding: ${unit(4)} ${unit(9)} ${unit(5)} ${unit(7)};
  font-weight: 400;
  text-align: left;
`
